import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/map';
import { environment } from '../../../environments/environment';

@Injectable()
export class MotivoInativacaoService {

  url: string = environment.BASE_URL;

  private motivoInativacao = new Subject<any>();
  motivoInativacao$ = this.motivoInativacao.asObservable();

  constructor(private http: HttpClient) {}

  getMotivosInativacaoAtivos(searchParams?: any): Observable<any> {
    const params = this.setParams(searchParams);
    return this.http.get(`${this.url}/motivosInativacao/ativos`, { params: params })
      .map(data => {
        const body = data;
        this.motivoInativacao.next(body);
        return body;
      });
  }

  setParams(searchParams: any) {
    let params = new HttpParams();
    if (!searchParams) {
      return params;
    }
    if (searchParams.key && searchParams.value) {
      return params.set(searchParams.key, searchParams.value);
    }
    for (const key of Object.keys(searchParams)) {
      params = params.set(key, searchParams[key]);
    }
    return params;
  }

}
